import React, {Component} from 'react';
import {Modal,ModalHeader,ModalBody,ModalFooter, Container, Row, Col, Card, CardBody, CardFooter, Button, Input, InputGroup, InputGroupAddon} from 'reactstrap';
import { connect } from 'react-redux';
import $ from 'jquery';

class Register extends Component {

  constructor(props){
      super(props);
      //设置初始值
      this.state={
          email:'',
          password:'',
          devProjectCode:'',
          liveProjectCode:'',
          storeProjectCode:'',
          customerType:'campaign',
          successOpen:false

      }
      this.closeSuccess = this.closeSuccess.bind(this);
      this.changeSelectValue = this.changeSelectValue.bind(this);
      this.changeEmail = this.changeEmail.bind(this);
      this.changePassword = this.changePassword.bind(this);
      this.changeDevProjectCode = this.changeDevProjectCode.bind(this);
      this.changeLiveProjectCode = this.changeLiveProjectCode.bind(this);
      this.changeStoreProjectCode = this.changeStoreProjectCode.bind(this);
      this.Register = this.Register.bind(this);



 }


 closeSuccess() {
  this.setState({successOpen:false,failOpen:false})
 }
 Register() {
     let data = {
      username: this.state.email,
      password:this.state.password,
      devProjectCode: this.state.devProjectCode,
      liveProjectCode: this.state.liveProjectCode,
      storeProjectCode: this.state.storeProjectCode,
      customerType:this.state.customerType

     }
     let jsonData = JSON.stringify(data);
     let authToken = this.props.user.authToken;
     console.log(authToken);
     console.log(jsonData);

     $.ajax({
          url: `https://screen.mobflic.com/v1/customers`,
          type: 'POST',
          contentType:"application/json",
          beforeSend: function (xhr) {
                  xhr.setRequestHeader ("X-Auth-Token",authToken);
          },
          data:jsonData,
          success: (res,a,b) => {
            console.log(res);
            this.setState({successOpen:true})


         },
        error: (res,a,b) => {
            this.setState({failOpen:true})
        }

      });
 }

 changeEmail(e) {
  this.setState({email:e.target.value})

 }

 changePassword(e) {
  this.setState({password:e.target.value})
 }

 changeSelectValue(e) {
  this.setState({customerType:e.target.value},()=> {console.log(this.state.customerType)})
 }

 changeStoreProjectCode(e) {
  this.setState({storeProjectCode:e.target.value})
 }

 changeDevProjectCode(e) {
  this.setState({devProjectCode:e.target.value})
 }




 changeLiveProjectCode(e) {
  this.setState({liveProjectCode:e.target.value})
 }
  render() {
    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="6">
              <Card className="mx-4">
                <CardBody className="p-4">
                  <h1>Register</h1>
                  <p className="text-muted">Create customer account</p>
                  <InputGroup className="mb-3">

                    <Input type="text" value = {this.state.email} onChange={(e)=>{this.changeEmail(e)}} placeholder="Email"/>
                  </InputGroup>
                  <InputGroup className="mb-3">
                    <Input type="text" value = {this.state.password} onChange={(e)=>{this.changePassword(e)}} placeholder="Password"/>
                  </InputGroup>
                  <InputGroup className="mb-3">
                    <Input type="text" value = {this.state.devProjectCode } onChange={(e)=>{this.changeDevProjectCode(e)}} placeholder="DevProjectCode"/>

                  </InputGroup>
                  <InputGroup className="mb-3">
                    <Input type="text" value = {this.state.liveProjectCode} onChange={(e)=>{this.changeLiveProjectCode(e)}} placeholder="LiveProjectCode"/>

                  </InputGroup>

                  <InputGroup className="mb-3">
                    <Input type="text" value = {this.state.storeProjectCode} onChange={(e)=>{this.changeStoreProjectCode(e)}} placeholder="StoreProjectCode"/>

                  </InputGroup>
                  <InputGroup className="mb-4">
                     <Input type="select" value={this.state.customerType} onChange={(e) => {this.changeSelectValue(e)}} name="select" id="select">
                        <option value="campaign">campaign</option>
                        <option value="corporate">corporate</option>
                        <option value="enterprise">enterprise</option>
                        <option value="managed">managed</option>

                      </Input>
                  </InputGroup>
                  <Button color="success" onClick={() => {this.Register()}} block>Create Account</Button>
                </CardBody>

              </Card>
            </Col>
          </Row>


          <Modal isOpen={this.state.successOpen} >
                  <ModalHeader toggle={this.toggleInfo}>Register Success</ModalHeader>
                  <ModalBody>
                   You have successfully registrated {this.state.email}

                  </ModalBody>
                  <ModalFooter>

                    <Button color="secondary" onClick={this.closeSuccess}>Ok</Button>
                  </ModalFooter>
          </Modal>


          <Modal isOpen={this.state.failOpen} >
                  <ModalHeader toggle={this.toggleInfo}>Register failed</ModalHeader>
                  <ModalBody>
                   Register failed. Please make sure the email is in right format and all lowercase.
                   Also Please make sure the projectCodes have never been used by other customers.

                  </ModalBody>
                  <ModalFooter>

                    <Button color="secondary" onClick={this.closeSuccess}>Ok</Button>
                  </ModalFooter>
          </Modal>




        </Container>
      </div>
    );
  }
}




function mapStateToProps(state) {
    return {
        user: state.activeUser,
    };
}



export default  connect(mapStateToProps)(Register);



// WEBPACK FOOTER //
// ./src/views/Pages/Register/Register.js